let jsPDF, autoTable, XLSX, exportGanttToPdf;

import("jspdf").then((x) => {
    jsPDF = x.jsPDF;
});
import("jspdf-autotable").then((x) => {
    autoTable = x.default;
});
import("xlsx").then((x) => {
    XLSX = x.default;
});

import("devextreme/pdf_exporter").then((x) => {
    exportGanttToPdf = x.exportGantt;
});

export function exportDatagrid(datagrid, filename, exportType) {
    var columns = datagrid.getVisibleColumns();

    datagrid.getDataSource().store().load({ filter: datagrid.getCombinedFilter() }).done(function (result) {
        var data = result.data;
        if (data.length > 0) {
            for (var dataField in data[0]) {
                if (!columns.filter(function (x) { return x.dataField === dataField }).length)
                    delete data[0][dataField];
            }
        }

        var columnNames = getColumnNames(columns);
        data = prepareData(columns, data);

        if (exportType == "pdf")
            exportToPDF(columnNames, data, filename);
        else
            exportToOther(columnNames, data, filename, exportType);
    });
}


function exportToPDF(columnNames, data, filename) {
    var doc = new jsPDF({ orientation: "landscape" });
    autoTable(doc, { head: [columnNames], body: data, startY: 10 });
    doc.save(filename + ".pdf");
}

function exportToOther(columnNames, data, filename, exportType) {
    data.unshift(columnNames);

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(data);

    XLSX.utils.book_append_sheet(wb, ws, "Sheet");
    XLSX.writeFile(wb, filename + "." + exportType);
}

function getColumnNames(columns) {
    var columnNames = [];
    columns.forEach(function (column) {
        if (typeof column.caption !== "undefined")
            columnNames.push(column.caption);
    });
    return columnNames;
}

function prepareData(columns, dataObject) {
    var dataArray = [];

    dataObject.forEach(function (rowObject) {
        var rowArray = [];
        columns.forEach(function (column) {
            if (typeof column.dataField !== "undefined")
                rowArray.push(rowObject[column.dataField]);
        });
        dataArray.push(rowArray);
    });

    return dataArray;
}











export function exportGantt(component, options) {
    options = options || {}
    options.fileName = options.fileName || "export-gantt.pdf"
    if (!options.fileName.endsWith(".pdf"))
        options.fileName += ".pdf";

    var ganttOptions = {
        component: component,
        format: options.format || "auto",
        landscape: options.landscape || true,
        exportMode: options.exportMode || "all",
        dateRange: options.dateRange || "all",
        margins: options.margins || void 0,
        createDocumentMethod: (args => {
            if (options.onCreateDocument)
                options.onCreateDocument(args)
            return new jsPDF(args)
        }),
    };

    exportGanttToPdf(ganttOptions).then(doc => {
        if (options.afterExport)
            options.afterExport(doc)
        doc.save(options.fileName)
    });
}